var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCaissonLabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 506.12 173.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#68842f;}.cls-4{fill:#66832e;}.cls-5{fill:#668729;}.cls-6{fill:#698530;}.cls-7{fill:#7d963b;}.cls-8{fill:#91a745;}.cls-9{fill:#738e35;}.cls-10{fill:#80993d;}.cls-11{fill:#65822e;}.cls-12{fill:#819a3d;}.cls-13{fill:#7e973c;}.cls-14{fill:#67832f;}.cls-15{fill:#64812d;}.cls-16{fill:#98ad49;}.cls-17{fill:#6b8731;}.cls-18{fill:#99ae4a;}.cls-19{fill:#97ac49;}.cls-20{fill:#6a8630;}.cls-21{fill:#7f983c;}.cls-22{fill:#7c963a;}.cls-23{fill:#a0b44e;}.cls-24{fill:#9fb34d;}.cls-25{fill:#849c3f;}.cls-26{fill:#9eb24d;}.cls-27{fill:#93a847;}.cls-28{fill:#8aa142;}.cls-29{fill:#b5c659;}.cls-30{fill:#b8c85b;}.cls-31{fill:#9db14c;}.cls-32{fill:#8ba242;}.cls-33{fill:#9cb04c;}.cls-34{fill:#8ca243;}.cls-35{fill:#8fa544;}.cls-36{fill:#90a645;}.cls-37{fill:#b6c75a;}.cls-38{fill:#c1d060;}.cls-39{fill:#b3c458;}.cls-40{fill:#b4c559;}.cls-41{fill:#728d35;}.cls-42{fill:#baca5c;}.cls-43{fill:#8da343;}.cls-44{fill:#b9c95c;}.cls-45{fill:#8ea444;}.cls-46{fill:#b7c75a;}.cls-47{fill:#92a846;}.cls-48{fill:#859d3f;}.cls-49{fill:#abbd54;}.cls-50{fill:#adbf55;}.cls-51{fill:#a5b851;}.cls-52{fill:#a8bb52;}.cls-53{fill:#bfce5f;}.cls-54{fill:#b1c257;}.cls-55{fill:#bccc5d;}.cls-56{fill:#aabc53;}.cls-57{fill:#a6b951;}.cls-58{fill:#aec056;}.cls-59{fill:#afc156;}.cls-60{fill:#b0c157;}.cls-61{fill:#a4b750;}.cls-62{fill:#b2c358;}.cls-63{fill:#bbcb5d;}.cls-64{fill:#a3b64f;}.cls-65{fill:#c0cf5f;}.cls-66{fill:#bdcd5e;}.cls-67{fill:#a9bb53;}.cls-68{fill:#becd5e;}.cls-69{fill:#acbe54;}.cls-70{fill:#a7ba52;}.cls-71{fill:#9baf4b;}.cls-72{fill:#6d8932;}.cls-73{fill:#6e8a33;}.cls-74{fill:#a1b44e;}.cls-75{fill:#94a947;}.cls-76{fill:#718c34;}.cls-77{fill:#a2b54f;}.cls-78{fill:#96ab48;}.cls-79{fill:#95aa48;}.cls-80{fill:#89a041;}.cls-81{fill:#537224;}.cls-82{fill:#869e40;}.cls-83{fill:#6c8832;}.cls-84{fill:#889f41;}.cls-85{fill:#9aae4a;}.cls-86{fill:#6f8a33;}.cls-87{fill:#5b7928;}.cls-88{fill:#597727;}.cls-89{fill:#63802d;}.cls-90{fill:#557425;}.cls-91{fill:#5c7a29;}.cls-92{fill:#577626;}.cls-93{fill:#5a7828;}.cls-94{fill:#567525;}.cls-95{fill:#587727;}.cls-96{fill:#839c3e;}.cls-97{fill:#708b34;}.cls-98{fill:#5f7d2a;}.cls-99{fill:#627f2c;}.cls-100{fill:#607d2b;}.cls-101{fill:#5d7b29;}.cls-102{fill:#547324;}.cls-103{fill:#748f36;}.cls-104{fill:#799339;}.cls-105{fill:#759037;}.cls-106{fill:#617e2c;}.cls-107{fill:#789238;}.cls-108{fill:#5e7c2a;}.cls-109{fill:#527123;}.cls-110{fill:#769037;}.cls-111{fill:#779138;}.cls-112{fill:#507022;}.cls-113{fill:#4f6f22;}.cls-114{fill:#829b3e;}.cls-115{fill:#517123;}.cls-116{fill:#7b953a;}.cls-117{fill:#4e6e21;}.cls-118{fill:#7a9439;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m263.7,64.49c9.8.39,16.74-5.62,24.37-11.52.17,4.96-2.25,7.89-4.93,10.5-11.25,10.93-25.1,12.71-39.81,10.51-6.45-.96-12.2-3.88-17.74-7.47-13.43-8.73-12.87-30.03,2.13-38.44,15.86-8.88,36.63-8.58,51.42,1.91,2.04,1.45,3.9,3.06,5.39,5.1,5.32,7.24,4.9,12.68-1.85,18.7-5.5,4.91-11.99,8.2-18.98,10.72Zm12.79-22.05c-2.14.18-3.1-.9-4.26-1.47-14.39-7.14-33.41-5.07-44.49,4.88-3.72,3.34-3.61,4.71.58,7.51,3.8,2.55,8.12,3.72,12.52,4.67,13.86,2.99,26.82,1.15,38.12-7.8,5.58-4.42,5.58-9.89.68-14.96-13.05-13.54-41.64-13.38-54.43.33-1.58,1.69-3.35,3.39-3.07,6.11.59,0,.79.06.91,0,1.3-.73,2.57-1.5,3.87-2.22,13.47-7.5,27.5-9.37,42.15-3.92,3.15,1.17,6.44,2.59,7.42,6.9Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 221.87,
    y: 21.73,
    width: 62.68,
    height: 16.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 221.87,
    y: 38.7,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 221.87,
    y: 39.01,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 221.87,
    y: 39.32,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 221.87,
    y: 39.62,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 221.87,
    y: 39.93,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 221.87,
    y: 40.24,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 221.87,
    y: 40.54,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 221.87,
    y: 40.85,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 221.87,
    y: 41.16,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 221.87,
    y: 41.47,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 221.87,
    y: 41.77,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 221.87,
    y: 42.08,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 221.87,
    y: 42.39,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 221.87,
    y: 42.7,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 221.87,
    y: 43,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 221.87,
    y: 43.31,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 221.87,
    y: 43.62,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 221.87,
    y: 43.93,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 221.87,
    y: 44.23,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 221.87,
    y: 44.54,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 221.87,
    y: 44.85,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 221.87,
    y: 45.15,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 221.87,
    y: 45.46,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 221.87,
    y: 45.77,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.87,
    y: 46.08,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 221.87,
    y: 46.38,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 221.87,
    y: 46.69,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 221.87,
    y: 47,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 221.87,
    y: 47.31,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 221.87,
    y: 47.61,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 221.87,
    y: 47.92,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 221.87,
    y: 48.23,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 221.87,
    y: 48.53,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 221.87,
    y: 48.84,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 221.87,
    y: 49.15,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 221.87,
    y: 49.46,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 221.87,
    y: 49.76,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 221.87,
    y: 50.07,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 221.87,
    y: 50.38,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 221.87,
    y: 50.69,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 221.87,
    y: 50.99,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 221.87,
    y: 51.3,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 221.87,
    y: 51.61,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 221.87,
    y: 51.91,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 221.87,
    y: 52.22,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 221.87,
    y: 52.53,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 221.87,
    y: 52.84,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 221.87,
    y: 53.14,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 221.87,
    y: 53.45,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 221.87,
    y: 53.76,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 221.87,
    y: 54.07,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 221.87,
    y: 54.37,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 221.87,
    y: 54.68,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 221.87,
    y: 54.99,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 221.87,
    y: 55.29,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 221.87,
    y: 55.6,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 221.87,
    y: 55.91,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 221.87,
    y: 56.22,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 221.87,
    y: 56.52,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 221.87,
    y: 56.83,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 221.87,
    y: 57.14,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 221.87,
    y: 57.45,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 221.87,
    y: 57.75,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 221.87,
    y: 58.06,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 221.87,
    y: 58.37,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 221.87,
    y: 58.67,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 221.87,
    y: 58.98,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 221.87,
    y: 59.29,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 221.87,
    y: 59.6,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 221.87,
    y: 59.9,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 221.87,
    y: 60.21,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 221.87,
    y: 60.52,
    width: 62.68,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 221.87,
    y: 60.83,
    width: 62.68,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 212.17,
    y: 19.19,
    width: 77.69,
    height: 19.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 212.17,
    y: 38.7,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 212.17,
    y: 39.01,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 212.17,
    y: 39.32,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 212.17,
    y: 39.62,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 212.17,
    y: 39.93,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 212.17,
    y: 40.24,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 212.17,
    y: 40.54,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 212.17,
    y: 40.85,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 212.17,
    y: 41.16,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 212.17,
    y: 41.47,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 212.17,
    y: 41.77,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 212.17,
    y: 42.08,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 212.17,
    y: 42.39,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 212.17,
    y: 42.7,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 212.17,
    y: 43,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 212.17,
    y: 43.31,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 212.17,
    y: 43.62,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 212.17,
    y: 43.93,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 212.17,
    y: 44.23,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 212.17,
    y: 44.54,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 212.17,
    y: 44.85,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 212.17,
    y: 45.15,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 212.17,
    y: 45.46,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 212.17,
    y: 45.77,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 212.17,
    y: 46.08,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 212.17,
    y: 46.38,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 212.17,
    y: 46.69,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 212.17,
    y: 47,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 212.17,
    y: 47.31,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 212.17,
    y: 47.61,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 212.17,
    y: 47.92,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 212.17,
    y: 48.23,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 212.17,
    y: 48.53,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 212.17,
    y: 48.84,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 212.17,
    y: 49.15,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 212.17,
    y: 49.46,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 212.17,
    y: 49.76,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 212.17,
    y: 50.07,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 212.17,
    y: 50.38,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 212.17,
    y: 50.69,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 212.17,
    y: 50.99,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 212.17,
    y: 51.3,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 212.17,
    y: 51.61,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 212.17,
    y: 51.91,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 212.17,
    y: 52.22,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 212.17,
    y: 52.53,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 212.17,
    y: 52.84,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 212.17,
    y: 53.14,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 212.17,
    y: 53.45,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 212.17,
    y: 53.76,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 212.17,
    y: 54.07,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 212.17,
    y: 54.37,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 212.17,
    y: 54.68,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 212.17,
    y: 54.99,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 212.17,
    y: 55.29,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 212.17,
    y: 55.6,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 212.17,
    y: 55.91,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 212.17,
    y: 56.22,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 212.17,
    y: 56.52,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 212.17,
    y: 56.83,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 212.17,
    y: 57.14,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 212.17,
    y: 57.45,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 212.17,
    y: 57.75,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 212.17,
    y: 58.06,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 212.17,
    y: 58.37,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 212.17,
    y: 58.67,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 212.17,
    y: 58.98,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 212.17,
    y: 59.29,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 212.17,
    y: 59.6,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 212.17,
    y: 59.9,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 212.17,
    y: 60.21,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 212.17,
    y: 60.52,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 212.17,
    y: 60.83,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 212.17,
    y: 61.13,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 212.17,
    y: 61.44,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 212.17,
    y: 61.75,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 212.17,
    y: 62.06,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 212.17,
    y: 62.36,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 212.17,
    y: 62.67,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 212.17,
    y: 62.98,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 212.17,
    y: 63.28,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 212.17,
    y: 63.59,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 212.17,
    y: 63.9,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 212.17,
    y: 64.21,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 212.17,
    y: 64.51,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 212.17,
    y: 64.82,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 212.17,
    y: 65.13,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 212.17,
    y: 65.44,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 212.17,
    y: 65.74,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 212.17,
    y: 66.05,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 212.17,
    y: 66.36,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 212.17,
    y: 66.66,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 212.17,
    y: 66.97,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 212.17,
    y: 67.28,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 212.17,
    y: 67.59,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 212.17,
    y: 67.89,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 212.17,
    y: 68.2,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 212.17,
    y: 68.51,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 212.17,
    y: 68.82,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 212.17,
    y: 69.12,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 212.17,
    y: 69.43,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 212.17,
    y: 69.74,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 212.17,
    y: 70.04,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 212.17,
    y: 70.35,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 212.17,
    y: 70.66,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 212.17,
    y: 70.97,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 212.17,
    y: 71.27,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 212.17,
    y: 71.58,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 212.17,
    y: 71.89,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 212.17,
    y: 72.2,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 212.17,
    y: 72.5,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 212.17,
    y: 72.81,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 212.17,
    y: 73.12,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 212.17,
    y: 73.42,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 212.17,
    y: 73.73,
    width: 77.69,
    height: 0.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 212.17,
    y: 74.04,
    width: 77.69,
    height: 2.14
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m184.4,113.29c0-3.47.29-6.96-.06-10.4-.84-8.31-7.86-13.78-16.81-13.39-8.42.37-14.59,6.57-14.88,14.96-.31,8.89,5.27,15.71,13.69,16.56,3.31.34,6.63.19,9.9-.52,1.12-.24,2.48-.75,3.21.41.82,1.3-.09,2.53-.92,3.58-1.18,1.51-2.83,2.25-4.65,2.65-11.95,2.56-24.32-4.86-27.09-16.25-2.88-11.84,4.31-24.2,15.81-27.18,12.13-3.14,24.29,3.62,27.7,15.73,2.09,7.42,1.34,15.08.68,22.65-.11,1.22-.92,2.46-1.65,3.52-.66.97-1.73,1.64-3.01,1.32-1.4-.35-1.6-1.63-1.62-2.76-.08-3.63-.03-7.27-.03-10.9-.1,0-.19,0-.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m315.38,83.26c12.42.02,22.62,10.12,22.46,22.24-.16,12.23-10.27,21.94-22.8,21.92-12.39-.02-22.66-10.17-22.51-22.26.15-12.19,10.29-21.92,22.85-21.89Zm15.75,22.32c.07-9.41-6.34-16-15.66-16.1-9.38-.1-16.14,6.4-16.23,15.61-.09,9.33,6.43,15.99,15.76,16.09,9.4.1,16.07-6.35,16.13-15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m229.46,83.29c7.18-.38,12.54,2.56,16.98,7.44.84.92,2.21,1.95,1.13,3.37-.87,1.14-2.35,1.05-3.7.84-2.07-.32-3.48-1.84-5.17-2.87-5.54-3.38-11.29-3.58-17.06-.76-1.74.85-3.73,2.09-3.48,4.4.22,1.98,2.06,2.94,3.81,3.54,4.07,1.4,8.2,2.65,12.29,4,3.77,1.24,7.67,2.25,10.74,4.99,3.91,3.49,4.38,7.12,1.51,11.43-7.61,11.41-29.56,10.06-35.74-2.15-1.26-2.49-.4-3.26,2.05-3.42,2.64-.17,4.23,1.5,6,3.03,5.3,4.57,13.55,5.52,19,2.24,1.57-.95,3.19-1.96,3.22-4.08.04-2.24-1.71-3.16-3.41-3.79-4.19-1.55-8.45-2.9-12.68-4.34-2.35-.8-4.77-1.46-7.02-2.49-9.24-4.24-9.9-11.33-1.65-17.4,4-2.95,8.48-4.48,13.18-3.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m271.08,127.27c-7.6.48-13.48-2.73-18.01-8.61-.84-1.09-2.35-2.39-.86-3.86,1.14-1.13,2.91-.99,4.24-.31,1.44.74,2.65,1.93,3.95,2.95,5.65,4.41,11.82,4.9,18.28,2.19,1.97-.82,4.08-2.07,3.92-4.62-.14-2.3-2.2-3.21-4.07-3.9-3.42-1.26-6.91-2.34-10.39-3.46-2.05-.66-4.16-1.16-6.18-1.9-4.43-1.62-9.19-3.38-9.64-8.85-.48-5.76,3.86-8.93,8.26-11.4,8.62-4.84,20.97-2.43,27.33,5.03.83.97,2.25,1.95,1.46,3.37-.83,1.49-2.54,1.33-4.04,1.14-1.92-.24-3.25-1.57-4.73-2.62-5.22-3.7-10.83-3.77-16.59-1.56-2.01.78-4.15,1.83-4.31,4.33-.17,2.72,2.23,3.49,4.19,4.27,2.61,1.05,5.33,1.83,8.02,2.69,2.21.71,4.47,1.3,6.66,2.05,8.05,2.78,11.55,6.24,11.14,10.94-.48,5.55-7.11,11.26-14.14,12.1-1.47.17-2.98.03-4.48.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m387.1,113.37c0,2.98.1,5.96-.04,8.92-.08,1.62.78,4.12-2.1,4.15-2.54.03-3.89-1.74-4.03-4.18-.16-2.8-.11-5.62-.13-8.43-.02-2.81.06-5.62-.03-8.43-.27-9.21-6.75-15.78-15.63-15.92-9.49-.15-16.23,5.83-16.78,15.29-.32,5.44-.1,10.91-.13,16.36,0,1.87-.14,3.76-1.96,4.8-2.05,1.18-4.19,1.32-4.19-1.75,0-8.08-1.15-16.24.73-24.21,2.73-11.52,12.65-17.9,25.27-16.64,10.01,1,18.52,10.42,18.97,21.1.13,2.97.02,5.95.02,8.93,0,0,.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m129.54,127.41c-9.74-.03-17.72-5.61-20.9-14.61-3.19-9.04-.35-18.88,7.21-25,6.92-5.61,17.45-6.4,25.21-1.72,1.83,1.1,5.17,2.18,3.84,4.82-1.45,2.89-4.44,1.71-7.01.53-12.41-5.67-24.34,1.51-24.08,14.42.23,11.43,12.18,18.76,22.86,14,1.06-.47,2.02-1.13,3.05-1.66,2.1-1.08,4.07-.61,5.26,1.22,1.3,1.98-.79,2.92-1.96,3.9-3.49,2.9-7.71,4.11-13.48,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m203.54,105.34c0,5.78.03,11.56-.01,17.33-.01,2.2-.06,4.55-3.2,4.52-3.17-.03-3.08-2.44-3.09-4.61-.03-11.56-.03-23.11,0-34.67,0-2.17-.05-4.55,3.16-4.51,3.17.04,3.1,2.43,3.12,4.59.05,5.78.02,11.56.02,17.33Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m204.03,151.92h7.07v2.09h-9.78v-15.05h2.71v12.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m237.43,150.5h-6.03l-1.26,3.5h-2.81l5.88-15.05h2.43l5.89,15.05h-2.82l-1.27-3.5Zm-5.27-2.11h4.51l-2.26-6.25-2.26,6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m258.62,154.01v-15.05h5.34c1.76,0,3.1.34,4.02,1.02s1.38,1.7,1.38,3.05c0,.69-.19,1.31-.58,1.86-.39.55-.95.98-1.69,1.28.84.22,1.49.64,1.95,1.25s.69,1.34.69,2.2c0,1.41-.47,2.5-1.41,3.26-.94.76-2.28,1.14-4.03,1.14h-5.68Zm2.71-8.71h2.65c.84,0,1.5-.18,1.97-.55.47-.37.71-.89.71-1.57,0-.74-.22-1.28-.66-1.61s-1.12-.5-2.05-.5h-2.63v4.23Zm0,1.92v4.7h3.01c.85,0,1.51-.2,1.99-.61.48-.41.72-.97.72-1.7,0-1.56-.83-2.36-2.48-2.4h-3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m295.92,150.13c0-.66-.24-1.17-.72-1.53-.48-.36-1.35-.72-2.6-1.08-1.26-.37-2.25-.77-3-1.22-1.42-.86-2.13-1.98-2.13-3.37,0-1.21.51-2.21,1.54-3,1.02-.79,2.35-1.18,3.98-1.18,1.08,0,2.05.19,2.9.58s1.51.94,2,1.65c.48.71.73,1.5.73,2.37h-2.7c0-.79-.25-1.4-.76-1.84-.51-.45-1.24-.67-2.19-.67-.88,0-1.57.18-2.06.55-.49.37-.73.88-.73,1.53,0,.55.26,1.01.79,1.38.53.37,1.4.73,2.61,1.08s2.19.74,2.92,1.19c.73.45,1.27.96,1.62,1.53.34.58.51,1.25.51,2.02,0,1.25-.5,2.25-1.49,2.99-1,.74-2.34,1.11-4.05,1.11-1.13,0-2.16-.2-3.11-.61-.95-.4-1.68-.96-2.2-1.67-.52-.71-.79-1.54-.79-2.48h2.71c0,.85.29,1.52.88,1.99.58.47,1.42.7,2.51.7.94,0,1.65-.18,2.12-.55.47-.37.71-.86.71-1.46Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCaissonLabs);
export default __webpack_public_path__ + "static/media/logo-caisson-labs.21ec4f7c442984ef465bf75739f5fca1.svg";
export { ForwardRef as ReactComponent };